import oneLine from 'common-tags/es/oneLine/oneLine';

import homepage from './homepage';
import covid from './measures/covid';
import income from './measures/income';
import essentials from './measures/essentials';
import food from './measures/food';
import home from './measures/home';
import health from './measures/health';
import about from './about';
import contact from './contact';

const data = {
    pages: [
        homepage,
        covid,
        income,
        essentials,
        food,
        home,
        health,
        about,
        contact,
    ],
    menu: [
        {
            name: 'Poverty measures',
            link: '/measures',
            submenu: [
                { name: 'COVID-19', link: '/covid' },
                { name: 'Income', link: '/income' },
                { name: 'Essentials', link: '/essentials' },
                { name: 'Health', link: '/health' },
                { name: 'Home', link: '/home' },
                { name: 'Food', link: '/food' },
            ],
        },
        {
            name: 'About the project',
            link: '/about',
        },
        {
            name: 'Contact us',
            link: '/contact',
        },
    ],
    general: {
        contact: {
            email: 'childpoverty@occ.org.nz',
            twitter: 'https://twitter.com/povertymonitor',
            facebook: 'https://www.facebook.com/childpovertymonitor',
        },
        sponsors: [
            {
                name: 'Office of the Children\'s Commissioner',
                url: 'https://www.occ.org.nz/',
                image: {
                    filename: 'childrens-commissioner-logo-colour.png',
                },
            },
            {
                name: 'JR McKenzie Trust',
                url: 'https://www.jrmckenzie.org.nz/',
                image: {
                    filename: 'jr-mckenzie-trust-logo-colour.png',
                    classes: 'w-20',
                },
            },
            {
                name: 'Otago University',
                url: 'https://www.otago.ac.nz/',
                image: {
                    filename: 'otago-university-logo-colour.png',
                    classes: 'w-64',
                },
            },
        ],
        message: oneLine`*The 2020 Child Poverty Monitor data mostly precedes the significant impact of the COVID-19 pandemic. 
            The full source of all data on this site is available in the 
            <a class="font-semibold underline-link-basic" href="https://hdl.handle.net/10523/10585">Child Poverty Monitor: Technical Report</a>, 
            produced by the New Zealand Child and Youth Epidemiology Service at the University of Otago. To find out 
            more about child poverty, you can read the Children’s Commissioner’s Expert Advisory Group report 
            <a class="font-semibold underline-link-basic" href="https://www.occ.org.nz/assets/Uploads/EAG/Final-report/Final-report-Solutions-to-child-poverty-evidence-for-action.pdf">Solutions to Child Poverty in New Zealand: Evidence for Action</a>. 
            To download the Child Poverty Monitor 2020 poster, 
            <a class="font-semibold underline-link-basic" href="/static/images/CHC0005%20Child%20Poverty%20Poster%202020%20DIGI.pdf">click here</a>.`,
        technicalReport: {
            download: 'https://hdl.handle.net/10523/10585',
            online: 'http://nzchildren.otago.ac.nz/',
        },
    },
};

export default data;
